import moment from 'moment';

import { InvoiceFormatChip } from '../components/Chips/InvoiceFormatChip.component';
import { InvoiceStatusChip } from '../components/Chips/InvoiceStatusChip.component';
import { formatPrice } from '../../shared/utils/format-price.util';
import type { Invoice } from '../types/invoice.type';
import type { InvoiceStatus } from '../types/invoice-status.type';
import type { InvoiceTableRow } from '../components/Tables/InvoiceListTable.component';

type Options = {
  onChangeStatus: (invoiceId: string, nextStatus: InvoiceStatus) => void | Promise<void>;
};

type InvoiceInterval = { from: string; to: string };

type InvoiceTableCell = InvoiceTableRow['cells'][number];

type CommonInvoiceCells = {
  invoiceNumber: InvoiceTableCell;
  status: InvoiceTableCell;
  format: InvoiceTableCell;
  period: InvoiceTableCell;
  totalHT: InvoiceTableCell;
  totalTTC: InvoiceTableCell;
  createdAt: InvoiceTableCell;
};

export function buildCommonInvoiceCells(
  invoice: Invoice,
  interval: InvoiceInterval,
  { onChangeStatus }: Options,
): CommonInvoiceCells {
  const from = moment(interval.from).format('DD/MM/YYYY');
  const to = moment(interval.to).format('DD/MM/YYYY');

  return {
    invoiceNumber: { key: 'invoiceNumber', content: invoice.invoiceNumber },
    status: {
      key: 'status',
      content: (
        <InvoiceStatusChip
          status={invoice.status}
          onChange={(nextStatus) => onChangeStatus(invoice.id, nextStatus)}
        />
      ),
    },
    format: { key: 'format', content: <InvoiceFormatChip format={invoice.format} /> },
    period: { key: 'period', content: `${from} → ${to}` },
    totalHT: { key: 'totalHT', content: formatPrice(invoice.amounts.totalHT) },
    totalTTC: { key: 'totalTTC', content: formatPrice(invoice.amounts.totalTTC) },
    createdAt: { key: 'createdAt', content: moment(invoice.createdAt).format('DD MMMM YYYY à HH:mm') },
  };
}
